import { throttle } from 'lodash-es';
import '@zr/common/js/header/_candidate_header_desktop_shared';
import '@zr/common/js/skip_to_content';
import { initFiltersMenu } from '../_filters_menu';
import { initNotifications } from '../../_notifications';
// import { initMessages } from '../../_messages';
import { initLocationCTAButton } from '../_location_cta';
import '../_auto-complete-header';
import '@static/js/light/candidate/_blank-search-suggestions';

initFiltersMenu();
if (!zr.page.model.isZDS) {
  initLocationCTAButton(() => {}, '[data-search-form] [name="location"]');
}
$(() => {
  const showSuggestionModal = () => {
    $('.search_suggestions').show();
    if (zr.page.model.isZDS && !zr.page.model.isMobile) {
      $('.search_suggestions_overlay').show();
    }
  };

  const hideSuggestionModal = () => {
    $('.search_suggestions').hide();
    if (zr.page.model.isZDS && !zr.page.model.isMobile) {
      $('.search_suggestions_overlay').hide();
    }
  };

  $(window).click(() => {
    hideSuggestionModal();
  });

  $('.search_suggestions, .title .search').click((event) => {
    event.stopPropagation();
  });

  const cleanFocusClass = (keepSuggestionsVisible) => {
    $('.search_anchor')
      .removeClass('focusTitle')
      .removeClass('focusLocation');

    if (keepSuggestionsVisible) {
      return;
    }
    hideSuggestionModal();
  };

  const toggleSettingsDropdown = (hide) => {
    const headerOpen = $('.header_new').hasClass('opened');
    let showDropdown = false;

    if (!hide) {
      showDropdown = !$('body').hasClass('site_header_open');
    }

    $('.item_settings_dropdown').toggle(showDropdown);
    $('body').toggleClass('site_header_open', showDropdown);
    $('.backdrop').toggleClass('active', headerOpen || showDropdown);
  };

  $(window).click((e) => {
    if (e.target.classList.contains('item_settings_btn')) {
      return;
    }
    if ($('body').hasClass('site_header_open')) {
      toggleSettingsDropdown(true);
    }
  });

  $('.candidate_nav')
    .delegate('.item_settings button', 'click', () => {
      toggleSettingsDropdown();
    });

  $('.search_form')
    .delegate('.search', 'focusin focusout', (e) => {
      const keepSuggestionsVisible = e.type === 'focusout';

      cleanFocusClass(keepSuggestionsVisible);
    })
    .delegate('.search', 'focusin', (e) => {
      const inpEl = e.target;
      const isTitleInp = inpEl.parentElement.classList.contains('title');
      let className = 'focusLocation';

      if (isTitleInp) {
        className = 'focusTitle';
        if (inpEl.value === '') {
          showSuggestionModal();
        }
      }
      $('.search_anchor').addClass(className);
    })
    .delegate('.title .search', 'input', (e) => {
      const inpEl = e.target;
      $('.search_suggestions').toggle(inpEl.value === '');
      if (zr.page.model.isZDS && !zr.page.model.isMobile) {
        if (inpEl.value === '') {
          $('.search_suggestions_overlay').show();
        } else {
          $('.search_suggestions_overlay').hide();
        }
      }
    })
    .delegate('.open_searchbox', 'click', () => {
      $('.header_new').addClass('opened');
      $('.backdrop')
        .addClass('active')
        .one('click', () => {
          $('.backdrop').removeClass('active');
          $('.header_new').removeClass('opened');
        });
    })
    .delegate('.job_search_close', 'click', () => {
      $('.header_new').removeClass('opened');
      $('.backdrop').removeClass('active');
    });

  if (!zr.page.model.isZDS) {
    $('.mobile .filters_form')
      .delegate('.filters .menu_wrap > button', 'focusin', () => {
        $('.backdrop')
          .addClass('active');
      })
      .delegate('.filters .menu_wrap > button', 'focusout', () => {
        $('.backdrop')
          .removeClass('active');
      });
  }

  if (zr.page.model.isLoggedIn) {
    // Temporarily disable unread messages notifications, see EMP-10381.
    // initMessages();

    // Fetch email address.
    $.get({
      url: '/api/profile',
      success(data) {
        const email = data?.data?.profile?.email_address; // eslint-disable-line camelcase

        if (email) {
          $('#myProfileEmailAddress').text(email);
        }
      },
      dataType: 'json',
      contentType: 'application/json',
      xhrFields: {
        withCredentials: true,
      },
    });

    if (zr.page.model.isMobile) {
      // Suggested Job Count
      const $suggestedJobsNum = $('[data-type="suggested_jobs_num"]');

      if ($suggestedJobsNum.length) {
        $.ajax({
          url: '/candidate/api/suggested-job-count/v1',
        }).done((data) => {
          if (!data.text) {
            return;
          }

          $suggestedJobsNum
            .attr('title', data.title)
            .html(data.text);

          setTimeout(() => {
            $suggestedJobsNum.addClass('num_suggested_jobs_loaded');
          }, 1);
        });
      }
    } else {
      initNotifications();

      // Suggested Job Count
      $.get({
        url: '/candidate/api/suggested-job-count/v1',
        success(data) {
          const suggestedJobsCount = data?.text;

          if (suggestedJobsCount) {
            $('[data-suggested-jobs-num]')
              .addClass('num_loaded')
              .text(suggestedJobsCount)
              .attr('title', `You have ${suggestedJobsCount} new suggested jobs.`);
          }
        },
        dataType: 'json',
        contentType: 'application/json',
        xhrFields: {
          withCredentials: true,
        },
      });
    }
  }

  if (zr.page.model.isZDS) {
    let collapseTimeout;

    // search value label overlays the collapsed search input so that we can
    // show the location without changing the input values
    const showSearchValueLabel = () => {
      const searchTitle = $('.search_form [name="search"]').val();
      const searchLocation = $('.search_form [name="location"]').val();
      if (searchLocation) {
        const searchValueString = searchTitle ? `${searchTitle} in ${searchLocation}` : `All Jobs in ${searchLocation}`;
        $('.search_value_label').html(searchValueString).show();
      }
    };
    const hideSearchValueLabel = () => {
      $('.search_value_label').hide();
    };

    const expandSearch = () => {
      clearInterval(collapseTimeout);
      $('.site_header_zds').addClass('expanded');
      hideSearchValueLabel();
    };
    const collapseSearch = () => {
      clearInterval(collapseTimeout);
      collapseTimeout = setTimeout(() => $('.site_header_zds').removeClass('expanded'), 100);
      showSearchValueLabel();
    };

    $('.backdrop').on('click', collapseSearch);
    $('.search_suggestions_overlay').on('click', collapseSearch);
    $('.site_content').on('click', collapseSearch);

    $('.search_form').on('focusin', '.search', expandSearch);

    $('.search_form').on('click', '.clear_btn', () => {
      $('.search_form .location').val('');
      $('.search_form .search').val('').focus();
    });

    // apply border to the header only when user scrolls
    const scrollThreshold = 30;
    const checkScrollThrottleMS = 100;
    const checkScroll = (event) => {
      if (event.target.scrollTop >= scrollThreshold) {
        document.body.classList.add('has_scrolled');
      } else {
        document.body.classList.remove('has_scrolled');
      }
    };
    $('.site_content').on('scroll resize', throttle(checkScroll, checkScrollThrottleMS));

    // initialize search value label on load
    showSearchValueLabel();

    initLocationCTAButton(expandSearch, '[data-search-form] [name="location"]');
  }
});
